export default __webpack_public_path__ + "static/media/11@2x.d56ef848.png";